




















































import { defineComponent, onMounted, reactive, toRefs } from '@vue/composition-api';
import DialogCom from '@/components/Dialog';
import Pagination from '@/components/Pagination';
import Box from '@/components/Box';
import request from '@/utils/request';
import addComma from '@/utils/addComma';
import { Message } from 'element-ui';
import { userInfor as userInfoRef } from '@/useable/login';
import svgCom from '@components/Svg/index';
const userInfor = userInfoRef.value;

export default defineComponent({
  name: 'editOne',
  components: {
    Box,
    Pagination,
    DialogCom,
    svgCom
  },
  setup(props: any, { root }) {
    const state: any = reactive({
      orderNo: null,
      referenceId: [],
      calculator: false,
      total: 5,
      pageSize: 5,
      page: 1,
      showPagination: true,
      tableConfig: {
        column: [
          // {key: 'referenceId', label: '单选', operate: true, width: 50 },
          {key: 'payCorpName', label: '付款企业名称'},
          {key: 'supplierName', label: '供应商名称'},
          {key: 'orderNo', label: '付款单号', width: 210},
          {key: 'amount', label: '付款金额', width: 130, custom: true, align: 'right', headerAlign: 'right'},
          {key: 'currency', label: '币种', width: 70},
          {key: 'orderTypeName', label: '付款单类型'},
          {key: 'orderStatusName', label: '付款单状态', width: 110},
          {key: 'planPayTime', label: '预计付款日期', width: 110},
        ],
        data: []
      }
    });
    const pageChange = (newPage, newSize) => {
      state.page = newPage;
      state.pageSize = newSize;
      submit();
    };
    const submit = async () => {
      const parms = {
        current	: state.page,
        size: state.pageSize,
      };
      const result = await request('financing', 'financingUndoList', parms);
      const { records, size, total, current } = result.data;
      state.showPagination = records.length > 0 ;
      state.tableConfig.data = records;
      state.total = total;
      state.pageSize = size;
      state.page = current;
    };
    const go = async () => {
      if (state.referenceId.length>0 && !userInfor.isCore) {
        const { code } = await request('financing', 'checkSupplierRegisterStatus');
        if (code === 2000) {
          root.$router.push({
            path: '/financing/edit/editTwo',
            query: {
              referenceId: state.referenceId.join(',')
            }
          });
        }
      } else {
        Message.warning('请选择融资付款单');
      }
    };
    const closeDialog = () => {
      state.calculator = false ;
    };

    const handleSelectionChange = (val) => {
      state.referenceId = val.map(row=>row.referenceId);
    };

    onMounted(async ()=>{
      await submit();
      // const myDiv = document.getElementsByClassName('el-checkbox__inner')[0];
      // myDiv.addEventListener('mouseover', ()=>{
      //   myDiv.title = '123';
      // });
      // const tooltip: any = document.querySelector('.el-checkbox__inner');
      // tooltip.setAttribute('data-tooltip', '你好');
      // el-checkbox__original
      const checkboxes = document.querySelectorAll('.el-checkbox__input.is-disabled');
      checkboxes.forEach((checkbox: any) => {
        checkbox.title = '距预计付款日小于5天，不可申请融资。';
      });
    });

    return {
      ...toRefs(state),
      go,
      pageChange,
      closeDialog,
      addComma,
      handleSelectionChange
    };
  },
});
